module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dateMinus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow left"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.datePlus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar item"
  }, [_c('div', {
    staticClass: "ui basic calendar",
    attrs: {
      "id": "calendar2"
    }
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [(!_vm.filters.dateTo) ? _c('i', {
    staticClass: "calendar icon"
  }) : _c('i', {
    staticClass: "close link icon",
    on: {
      "click": function($event) {
        _vm.clearDateTo()
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "date",
      "placeholder": "Date filter to",
      "autocomplete": "off"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text input item"
  }, [_c('div', {
    staticClass: "ui input left icon"
  }, [_c('i', {
    staticClass: "barcode icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.code),
      expression: "filters.code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search Code"
    },
    domProps: {
      "value": (_vm.filters.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filters.code = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui container",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Reservations\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _vm._l((_vm.reservations), function(reservation) {
    return _c('reservation-row', {
      key: reservation._id,
      attrs: {
        "reservation": reservation,
        "boats": _vm.boats
      },
      on: {
        "triggerDetails": _vm.openReservationDetails,
        "printReceipt": _vm.printReceipt
      }
    })
  }), _vm._v(" "), (_vm.reservations.length === 0) ? _c('div', {
    staticClass: "ui message"
  }, [_vm._v("\n          There are no reservations for selected date or search criteria.\n        ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "pickup receipt"
  }, [_c('p', [_vm._v("Code: "), _c('strong', [_vm._v(_vm._s(_vm.receipt.code))])]), _vm._v(" "), _c('p', [_vm._v("Boat: "), _c('strong', [_vm._v(_vm._s(_vm.receipt.boat))])])]), _vm._v(" "), _c('details-modal', {
    attrs: {
      "reservationProp": _vm.editReservation,
      "boats": _vm.boats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar item"
  }, [_c('div', {
    staticClass: "ui basic calendar",
    attrs: {
      "id": "calendar1"
    }
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "date",
      "placeholder": "Datum"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f42502"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Reservations.vue
// module id = 744
// module chunks = 1